import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import TabBar from '../../component/tab-bar/tab-bar';
import { CreateLectureSingleTab } from './tabs/single/create-lecture-single-tab';
import {
  CreateLectureSerialTab,
  LecturerIdWithActivityTypeId,
} from './tabs/serial/create-lecture-serial-tab';
import { SelectedSlotsState } from './tabs/serial/components/time-slots/types/selected-slots';
import './create-calendar-schedule-style.css';

export enum ScheduleType {
  EXAM,
  LECTURE,
}

interface CreateCalendarScheduleDialog {
  branchId: number;
  courseName: string;
  supportMultiple: boolean;
  timeSlot:
    | {
        start: Date;
        end: Date;
        classId?: number;
      }
    | null
    | undefined;

  onHide: () => any;
  onApprove: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
    attendanceRequired: boolean,
    lectureAttendanceSessionNumber: number,
    lectureBreakMinutes?: number,
    professorRetroactiveWorkingHours?: boolean,
  ) => any;
  scheduleType: ScheduleType;
  editTakenClassId?: number;
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  };
  /** Dialog title; defaults to create-mode wording */
  headerTitle?: string;
  /** When true, enables the retroactive working-hours checkbox */
  allowRetroactiveWorkingHoursSupport?: boolean;
  /** When false, locks the attendance-segments dropdown */
  allowEditAttedancePartialNumber?: boolean;
  /** When false, locks the add-break checkbox */
  allowEditBreakMinutes?: boolean;
  /** Optional default for the attendance-segments dropdown */
  studentAttendacePartialNumber?: number;
  /** When true, locks fields that must not change while editing an existing lecture */
  editMode?: boolean;
}

const tabs = ['סדרת מפגשים'];

export const CreateCalendarScheduleDialog: React.FC<
  CreateCalendarScheduleDialog
> = ({
  branchId,
  courseName,
  supportMultiple = false,
  timeSlot,
  onHide,
  onApprove,
  scheduleType,
  editTimeSlot,
  headerTitle = 'הוספת מפגש',
  allowRetroactiveWorkingHoursSupport = false,
  allowEditAttedancePartialNumber = true,
  allowEditBreakMinutes = true,
  studentAttendacePartialNumber,
  editMode = false,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const pages = [
    /*<CreateLectureSingleTab timeSlot={timeSlot} onHide={onHide} />,*/
    <CreateLectureSerialTab
      branchId={branchId}
      supportMultiple={supportMultiple}
      timeSlot={timeSlot}
      onHide={onHide}
      onApprove={onApprove}
      scheduleType={scheduleType}
      editTimeSlot={editTimeSlot}
      allowRetroactiveWorkingHoursSupport={allowRetroactiveWorkingHoursSupport}
      allowEditAttedancePartialNumber={allowEditAttedancePartialNumber}
      allowEditBreakMinutes={allowEditBreakMinutes}
      studentAttendacePartialNumber={studentAttendacePartialNumber}
      editMode={editMode}
    />,
  ];

  return (
    <Dialog
      header={() => (
        <div>
          <div>{headerTitle}</div>
          <div style={{ fontWeight: 'normal', fontSize: '16px' }}>
            {courseName}
          </div>
        </div>
      )}
      className="white-close-dialog"
      visible={true}
      headerStyle={{
        backgroundColor: '#73b74f',
        position: 'relative',
        background: 'linear-gradient(135deg, #4776E6, #8E54E9)',

        padding: '25px 30px',
        color: 'white',
      }}
      style={{
        width: '90vw',
        backgroundColor: 'white',
        /*padding: '8px',*/
        borderRadius: '8px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
        animation: 'modalFadeIn 0.4s ease-out',
      }}
      onHide={onHide}
    >
      <TabBar
        tabs={tabs}
        onClick={(index) => {
          setSelectedIndex(index);
        }}
      ></TabBar>

      <div style={{ marginTop: '16px' }}>{pages[selectedIndex]}</div>
    </Dialog>
  );
};
